import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Contact Information</h4>
            <div className="contact-item">
              <p><strong>Kolhapur Office</strong></p>
              <p>Plot no D-55, Gokulshirgaon MIDC</p>
              <p>Kolhapur - 416234</p>
              <p>
                📍{' '}
                <a
                  href="https://maps.app.goo.gl/VWbetrScSxLM1apA6?g_st=aw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Google Maps
                </a>
              </p>
              <p>📞 <a href="tel:+919404257415">+91 9404257415</a></p>
            </div>
            <div className="contact-item">
              <p><strong>Pune Office</strong></p>
              <p>6/1/1, Near Bazare Petrol Pump, Uruli Devachi</p>
              <p>Handewadi-Katraj Road, Pune - 412308</p>
              <p>
                📍{' '}
                <a
                  href="https://maps.app.goo.gl/RV39i8TFpzn1dxGW9?g_st=aw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Google Maps
                </a>
              </p>
              <p>📞 <a href="tel:+919372937239">+91 9372937239</a></p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li>🧵 Wire Products</li>
              <li>🛡 Fencing Solutions</li>
              <li>🔧 Hardware Supplies</li>
              <li>🏗 Structural Steel</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Service Areas</h4>
            <ul>
              <li>Maharashtra</li>
              <li>Goa</li>
              <li>Karnataka</li>
              <li>Nationwide Distribution</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Vardhaman Wire. All rights reserved.</p>
          <p>Environmentally conscious and socially responsible</p>
          <div className="developer-credits">
            <p>Developed by <strong>Robotech AI Technologies Pvt Ltd</strong></p>
            <p>Contact: <a href="tel:+919960810617">+91 9960810617</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;